import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import { OptionRow } from "/imports/ui/components/booking";

// Mobile filter bottom sheet — body switches on the active filter chip.
function ClassFilterSheet({ cls }) {
  const {
    filters,
    setFilter,
    availableSports,
    locationFilteredServices,
    availableAges,
    availableTrainers,
    serviceLocations,
    levelOptions,
    levelScope,
    levelValue,
    setLevelScope,
    activeSheet,
    closeSheet,
    handleSportChange,
    sheetTitles
  } = cls;

  const renderSheetBody = () => {
    switch (activeSheet) {
      case "sport":
        return (
          <>
            <OptionRow
              label="All Sports"
              selected={!filters.sport}
              onClick={() => {
                handleSportChange(null);
                closeSheet();
              }}
            />
            {availableSports.map((s) => (
              <OptionRow
                key={s._id}
                label={s.name}
                selected={filters.sport === s._id}
                onClick={() => {
                  handleSportChange(s._id);
                  closeSheet();
                }}
              />
            ))}
          </>
        );
      case "service":
        return (
          <>
            <OptionRow
              label="All Classes"
              selected={!filters.serviceId}
              onClick={() => {
                setFilter("serviceId", null);
                closeSheet();
              }}
            />
            {locationFilteredServices.map((s) => (
              <OptionRow
                key={s._id}
                label={s.name}
                selected={filters.serviceId === s._id}
                onClick={() => {
                  setFilter("serviceId", s._id);
                  closeSheet();
                }}
              />
            ))}
          </>
        );
      case "age":
        return (
          <>
            <OptionRow
              label="No preference"
              selected={!filters.age}
              onClick={() => {
                setFilter("age", null);
                closeSheet();
              }}
            />
            {availableAges.map((a) => (
              <OptionRow
                key={a.value}
                label={a.label}
                selected={filters.age === a.value}
                onClick={() => {
                  setFilter("age", a.value);
                  closeSheet();
                }}
              />
            ))}
          </>
        );
      case "level":
        return (
          <>
            <OptionRow
              label="All Levels"
              selected={levelScope !== "mine"}
              onClick={() => {
                setLevelScope(null);
                closeSheet();
              }}
            />
            {levelOptions.map((o) => (
              <OptionRow
                key={o.value}
                label={o.label}
                sublabel={o.sublabel}
                selected={levelValue === o.value}
                onClick={() => {
                  setLevelScope(o.value);
                  closeSheet();
                }}
              />
            ))}
          </>
        );
      case "trainer":
        return (
          <>
            <OptionRow
              label="All Trainers"
              selected={!filters.trainerId}
              onClick={() => {
                setFilter("trainerId", null);
                closeSheet();
              }}
            />
            {availableTrainers.map((t) => (
              <OptionRow
                key={t._id}
                label={t.name}
                selected={filters.trainerId === t._id}
                onClick={() => {
                  setFilter("trainerId", t._id);
                  closeSheet();
                }}
              />
            ))}
          </>
        );
      case "location":
        return (
          <>
            {serviceLocations.length > 1 && (
              <OptionRow
                label="All Locations"
                selected={!filters.locationId}
                onClick={() => {
                  setFilter("locationId", null);
                  closeSheet();
                }}
              />
            )}
            {serviceLocations.map((l) => (
              <OptionRow
                key={l._id}
                label={l.name}
                selected={filters.locationId === l._id}
                onClick={() => {
                  setFilter("locationId", l._id);
                  closeSheet();
                }}
              />
            ))}
          </>
        );
      default:
        return null;
    }
  };

  return (
    <Drawer
      anchor="bottom"
      open={!!activeSheet}
      onClose={closeSheet}
      PaperProps={{ sx: { borderTopLeftRadius: 20, borderTopRightRadius: 20, maxHeight: "75vh", px: 2.5, pt: 2, pb: 3 } }}
    >
      <Box sx={{ width: "2.5rem", height: "0.25rem", borderRadius: 2, bgcolor: "divider", mx: "auto", mb: 2 }} />
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
        <Typography sx={{ fontSize: "1.05rem", fontWeight: 700 }}>{sheetTitles[activeSheet] || ""}</Typography>
        <IconButton size="small" onClick={closeSheet} aria-label="Close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, overflowY: "auto" }}>{renderSheetBody()}</Box>
    </Drawer>
  );
}

export default ClassFilterSheet;
